import React, {useEffect, useRef, useState} from "react";
import axios from 'axios';
import HeadRegresar from "../../sharecomponents/HeadRegresar";
import {API_URL} from "../../../utils/Common";
import ImprimirEtiquetaCama from "./ImprimirEtiquetaCama";

const VerAsignacionesValvula = (props) => {
    const planId = props.match.params.id; // -- el ID del plan
    const [valvulas, setValvulas] = useState([]);
    const compRef = useRef();

    useEffect(() => {
        axios.get(API_URL + '/getValvulasCamasAsignadas', {params: { planId }})
            .then(r => {
                console.log(r.data);
                setValvulas(r.data.valvulas);
            })
            .catch(e => console.log(e));
    }, [planId]);

    const goImpEtiqueta = (v) => {
        console.log( v);
        console.log(compRef);
        compRef.current.setInfoEt(v);
    }

    return (
        <div className="w-full p-3 right-0">
            <div className="bg-white border rounded shadow-xl">
                <div className="border-b rounded-t p-3 bg-orange-900">
                    <HeadRegresar titulo="Válvulas Asignadas" history={props.history} />
                </div>
                <div className="p-5 rounded-b">
                    <div className="flex max-w-full max-h-full">
                        <div className="w-1/2 p-2 h-auto">
                            {
                                valvulas.map((v, i) => {
                                    return (
                                        <table key={i} className="mb-5 shadow w-full">
                                            <caption className="text-left text-orange-900 font-bold mb-2 bg-orange-200 py-1 px-1 border border-orange-800 rounded">
                                                <span className="ml-2">Código de Válvula: { v.valvula.codigo }</span><br/>
                                                <div className="text-sm bg-white rounded px-1 py-2 mx-1 my-2 border border-orange-200">
                                                    Camas Utilizadas: <b>{v.nocamas}</b> Fecha Asignación: <b>{v.fecha_asignacion}</b>
                                                    <button className="text-white text-sm bg-orange-800 rounded hover:bg-orange-600 focus:outline-none px-2 py-1 ml-2"
                                                            onClick={() => goImpEtiqueta(v)}>
                                                        Generar Etiquetas
                                                    </button>
                                                </div>
                                            </caption>
                                            <thead>
                                            <tr className="text-sm border border-orange-800 text-white content-center bg-orange-800">
                                                <th className="px-4 py-2">No. Cama</th>
                                                <th className="px-4 py-2">Tipo FLor</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                v.camas.map((c, j) => {
                                                    return (
                                                        <tr key={j} className="text-sm">
                                                            <td className="text-center border px-4 py-2">{ c.indice }</td>
                                                            <td className="text-center border px-4 py-2">{ c.nombreTipoFlor }</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    )
                                })
                            }
                        </div>
                        <div className="content-center w-1/2 p-2 h-auto">
                            <ImprimirEtiquetaCama ref={compRef}/>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default VerAsignacionesValvula;
